import { useEffect, useState } from "react";
import { CreditSummary } from "./paymentHistoryComponents/credit-summary";
import TransactionHistory from "./paymentHistoryComponents/transaction-history";
import type { CreditSummary as CreditSummaryType } from "./paymentHistoryLib/paymentHistoryTypes";
import { useBrand } from "@/Providers/Brand";

// This is mock data. In a real application, you'd fetch this from your backend.
// const creditSummaries: CreditSummaryType[] = [
//   {
//     type: "Campaign Credits",
//     available: 1000,
//     used: 500,
//     info: "Credits for running marketing campaigns",
//   },
//   {
//     type: "Collaboration Credits",
//     available: 2000,
//     used: 750,
//     info: "Credits for collaborative projects",
//   },
//   {
//     type: "Anchors Credits",
//     available: 1500,
//     used: 250,
//     info: "Credits for anchor-based activities",
//   },
// ];

export default function BrandPaymentHistory() {
  const brandState = useBrand();
  const [creditSummaries, setCreditSummaries] = useState<CreditSummaryType[]>(
    []
  );

  useEffect(() => {
    const getCreditSummaries = async () => {
      const result = await brandState?.getCreditsStats();
      if (result?.success) {
        setCreditSummaries(result.data);
      } else {
        console.error("Error fetching credit summaries:", result.error);
        setCreditSummaries([]);
      }
    };
    getCreditSummaries();
  }, []);

  return (
    <div className="min-h-screen bg-white py-8">
      <div className="w-full max-w-6xl mx-auto px-4">
        <CreditSummary summaries={creditSummaries} />
        <TransactionHistory />
      </div>
    </div>
  );
}
